import { UserRoleCreatableInterface } from '../interfaces/user-role-creatable.interface';
import { UserRoleDto } from './user-role.dto';
import { PickType } from '@nestjs/swagger';

export class UserRoleCreateDto
  extends PickType(UserRoleDto, ['userId', 'roleId'])
  implements UserRoleCreatableInterface {}
